import { GzToggleWebComponent } from './component/GzToggleWebComponent';
import { WEB_COMPONENT_GZ_TOGGLE } from '../../webcomponents.constants';

export { GzToggleWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_TOGGLE, GzToggleWebComponent);

/**
 *  Examples:
 *  Default toggle =>
 *  <gz-toggle"></gz-toggle>
 *
 *  Default disabled toggle =>
 *  <gz-toggle disabled></gz-toggle>
 *
 *  Default checked toggle =>
 *  <gz-toggle checked></gz-toggle>
 *
 *  Anything between <gz-toggle> tags will be treat as toggle label =>
 *  <gz-toggle>Here your text for toggle label</gz-toggle>
 *
 */
